import classNames from 'classnames/bind';
import { getMonth, getYear, isValid } from 'date-fns';
import React, { useEffect } from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { DateType } from '../../DateRange.types';
import styles from './CustomHeader.module.scss';
import Icon, { ICONS } from '../../../Icon';
import { DATE_FORMATS } from '../../DateRange.constants';
import { formatDate, isBeforeOrEqualIgnoringTime } from '../../dateRangeUtils';

const cx = classNames.bind(styles);

interface CustomHeaderProps extends ReactDatePickerCustomHeaderProps {
  inputValue: DateType;
}

const CustomHeader = ({
  date,
  decreaseMonth,
  decreaseYear,
  increaseMonth,
  increaseYear,
  changeMonth,
  changeYear,
  inputValue,
}: CustomHeaderProps): React.ReactElement => {
  useEffect(() => {
    if (inputValue && isValid(inputValue) && isBeforeOrEqualIgnoringTime(inputValue, new Date())) {
      const month = getMonth(inputValue);
      const year = getYear(inputValue);
      changeMonth(month);
      changeYear(year);
    }
  }, [inputValue]);

  return (
    <div className={cx('body')}>
      <div className={cx('navigation')}>
        <button
          type="button"
          className={cx('caret-button')}
          onClick={decreaseYear}
          data-testid="date-picker-double-left-caret"
        >
          <Icon name={ICONS.CaretDoubleLeft} />
        </button>
        <button
          type="button"
          className={cx('caret-button')}
          onClick={decreaseMonth}
          data-testid="date-picker-left-caret"
        >
          <Icon name={ICONS.CaretLeft} />
        </button>
      </div>
      <span className={cx('current-month')} data-testid="date-picker-current-date">
        {formatDate(date, DATE_FORMATS.MONTH_YEAR)}
      </span>
      <div className={cx('navigation')}>
        <button
          type="button"
          className={cx('caret-button')}
          onClick={increaseMonth}
          data-testid="date-picker-double-right-caret"
        >
          <Icon name={ICONS.CaretRight} />
        </button>
        <button
          type="button"
          className={cx('caret-button')}
          onClick={increaseYear}
          data-testid="date-picker-right-caret"
        >
          <Icon name={ICONS.CaretDoubleRight} />
        </button>
      </div>
    </div>
  );
};

export default CustomHeader;
